import dayjs from "dayjs";
import { useEffect, useState } from "react";
import duration from "dayjs/plugin/duration";

// Hooks
import useTranslate from "hooks/useTranslate";

import "./styles.sass";

type TournamentTimerProps = {
  finishDate: string;
};

const INITIAL_STATE = {
  days: "00",
  hours: "00",
  minutes: "00",
  seconds: "00",
};

const TournamentTimer = (props: TournamentTimerProps) => {
  const { finishDate } = props;

  const [timer, setTimer] = useState(INITIAL_STATE);

  const t = useTranslate();

  // eslint-disable-next-line consistent-return
  useEffect(() => {
    if (finishDate) {
      const interval: NodeJS.Timeout = setInterval(() => {
        const now = dayjs();
        const finish = dayjs(finishDate);

        dayjs.extend(duration);
        const diff = dayjs.duration(finish.diff(now));
        const days = diff.get("d");
        const hours = diff.get("hour");
        const minutes = diff.get("minute");
        const seconds = diff.get("second");
        if (days < 0) {
          // eslint-disable-next-line unused-imports/no-unused-vars
          setTimer((prev) => INITIAL_STATE);
          clearInterval(interval);
          return;
        }
        setTimer((prev) => ({
          ...prev,
          days: days >= 10 ? `${days}` : `0${days}`,
          hours: hours >= 10 ? `${hours}` : `0${hours}`,
          minutes: minutes >= 10 ? `${minutes}` : `0${minutes}`,
          seconds: seconds >= 10 ? `${seconds}` : `0${seconds}`,
        }));
      }, 1000);
      return () => {
        clearInterval(interval);
      };
    }
  }, [finishDate]);

  return (
    <div className="TournamentTimer">
      <div className="TournamentTimer__block">
        <div className="TournamentTimer__digit">{timer.days}</div>
        <div className="TournamentTimer__text">
          {t("tournament.card.timer.days")}
        </div>
      </div>
      <div className="TournamentTimer__block">
        <div className="TournamentTimer__digit">{timer.hours}</div>
        <div className="TournamentTimer__text">
          {t("tournament.card.timer.hours")}
        </div>
      </div>
      <div className="TournamentTimer__block">
        <div className="TournamentTimer__digit">{timer.minutes}</div>
        <div className="TournamentTimer__text">
          {t("tournament.card.timer.minutes")}
        </div>
      </div>
      <div className="TournamentTimer__block">
        <div className="TournamentTimer__digit">{timer.seconds}</div>
        <div className="TournamentTimer__text">
          {t("tournament.card.timer.seconds")}
        </div>
      </div>
    </div>
  );
};

export default TournamentTimer;
